import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  templateUrl: './dialog-nt9-avviso.component.html',
  styleUrls: ['./utenti.component.css'],
  standalone: true,
  imports: [ButtonModule]
})
export class DialogNt9AvvisoComponent {
  constructor(public ref: DynamicDialogRef) {}
  close() {
    this.ref.close();
  }
} 